import { ISystemWideRules } from '../models/systemWideRules.model'
import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_MASTER_SETUP_SERVICE_URL || '' }

export const getSystemWideRules = (): Promise<any> => {
  return axiosInstance.get(`/api/systemWideRules`, config)
}

export const updateSystemWideRules = (data: ISystemWideRules): Promise<any> => {
  return axiosInstance.put(`/api/systemWideRules`, data, config)
}

// Global exception defaults (cutoff times / reminder) for non-Super-Admin screens such as Client Setup.
// Reads the same SystemDefaults source as System-Wide Rules but is gated on Client Setup view access.
export const getGlobalExceptionDefaults = (): Promise<any> => {
  return axiosInstance.get(`/api/globalExceptionDefaults`, config)
}
